import React, { useEffect, useState } from 'react';
import { Fab, Zoom, useScrollTrigger } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { DRAWER_WIDTH_CLOSED } from '../../constants/layout';

interface ScrollToTopProps {
  threshold?: number;
}

const drawerWidthClosed = DRAWER_WIDTH_CLOSED;

export const ScrollToTop: React.FC<ScrollToTopProps> = ({ threshold = 400 }) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  
  // Trigger shows/hides button based on scroll position
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: threshold,
  });

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Zoom in={trigger}>
      <Fab
        onClick={handleClick}
        color="primary"
        size="medium"
        aria-label="scroll back to top"
        sx={{
          position: 'fixed',
          bottom: 24,
          opacity: 0.6,
          right: isMdUp ? 'auto' : 24,
          left: isMdUp ? `calc(50% + ${drawerWidthClosed / 2}px)` : 'auto',
          transform: isMdUp ? 'translateX(-50%)' : 'none',
          zIndex: 1000,
          transition: theme.transitions.create(['left', 'right'], {
            duration: theme.transitions.duration.standard,
          }),
        }}
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </Zoom>
  );
};